import {
	ChangeDetectorRef,
	Component,
	Input,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import {
	LatLng,
	MapOptions,
	Marker,
	icon,
	latLng,
	marker,
	tileLayer,
} from 'leaflet';

import { Job } from 'src/shared/api';
import { jobsFragments } from '../../jobs.routes';

@Component({
	selector: 'rpfsa-job-details-card',
	templateUrl: './job-details-card.component.html',
	styleUrls: ['./job-details-card.component.scss'],
})
export class JobDetailsCardComponent implements OnChanges {
	@Input() job: Job;

	jobsFragments = jobsFragments;
	showMap = false;
	marker: Marker;
	mapCenter: LatLng;
	zoom = 7;
	baseOptions: MapOptions = {
		layers: [
			tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
			}),
		],
		zoomControl: true,
	};

	constructor(private ref: ChangeDetectorRef) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.job.currentValue) {
			const coordinates: LatLng = latLng(
				this.job.latitude,
				this.job.longitude
			);
			this.mapCenter = coordinates;
			setTimeout(() => {
				this.ref.markForCheck();
				this.showMap = true;
			}, 0);
			this.marker = marker(coordinates, {
				icon: icon({
					iconSize: [25, 41],
					iconAnchor: [13, 41],
					iconUrl: 'admin-assets/marker-icon.png',
					shadowUrl: 'admin-assets/marker-shadow.png',
				}),
			});
		}
	}
}
